import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import BACKEND_URL from '../../../api';
import '../../../Admin.css';

export default function AdminLogin() {
    const navigate = useNavigate();
    const location = useLocation();
    const [credentials, setCredentials] = useState({
        username: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    // Check if already logged in
    useEffect(() => {
        const adminToken = sessionStorage.getItem('adminToken');
        const adminUser = sessionStorage.getItem('adminUser');
        if (adminToken && adminUser) {
            // Redirect to admin page if already logged in
            const redirectTo = location.state?.from || '/admin/countries';
            navigate(redirectTo, { replace: true });
        }
    }, [navigate, location]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCredentials({
            ...credentials,
            [name]: value
        });
        setError(''); // Clear error on input change
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        if (!credentials.username || !credentials.password) {
            setError('Please enter both username and password');
            setLoading(false);
            return;
        }

        try {
            const response = await fetch(`${BACKEND_URL}/admin/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(credentials)
            });

            const data = await response.json();

            if (data.status === 'success') {
                // Store admin session
                sessionStorage.setItem('adminToken', data.token || 'admin_authenticated');
                sessionStorage.setItem('adminUser', JSON.stringify(data.user || { username: credentials.username }));
                
                // Redirect to admin page
                const redirectTo = location.state?.from || '/admin/countries';
                navigate(redirectTo, { replace: true });
            } else {
                setError(data.message || 'Invalid username or password');
            }
        } catch (error) {
            console.error('Login error:', error);
            setError('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-container">
            <div className="admin-login-box">
                <div className="admin-login-header">
                    <h1>Admin Login</h1>
                    <p>Enter your credentials to access the admin panel</p>
                </div>

                {error && (
                    <div className="alert alert-danger" style={{ marginBottom: '20px' }}>
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <input
                            type="text"
                            id="username"
                            name="username"
                            value={credentials.username}
                            onChange={handleInputChange}
                            placeholder="Enter your username"
                            required
                            autoFocus
                            disabled={loading}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={credentials.password}
                            onChange={handleInputChange}
                            placeholder="Enter your password"
                            required
                            disabled={loading}
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                        style={{ width: '100%', marginTop: '10px' }}
                    >
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>

                <div style={{ marginTop: '20px', textAlign: 'center', fontSize: '13px', color: '#666' }}>
                    <p>Authorized personnel only</p>
                </div>
            </div>
        </div>
    );
}

